import { BulletinBoardIcon } from './BulletinBoardIcon';

/**
 * author: Simran
 * id 094C9BF2-9EEE-434C-9CA9-8280FBDFBEF7
 * name bulletin-board
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bulletin-board.svg
 * tags
 */
export const NoticeBoardIcon = BulletinBoardIcon;
export default NoticeBoardIcon